// components/Pagination/Pagination.tsx
import React from 'react';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    disabled?: boolean;
    onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange, disabled = false }) => {
    if (totalPages <= 1) return null;

    return (
        <nav aria-label="Page navigation" className="mt-8">
            <div className="flex flex-wrap gap-2 items-center justify-center">
                <button 
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={disabled || currentPage === 1}
                    className="px-4 py-2 text-gray-700 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Anterior
                </button>
                
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => Math.max(1, Math.min(currentPage - 2, totalPages - 4)) + i).map((page) => (
                    <button
                        disabled={disabled}
                        aria-current={page === currentPage ? 'page' : undefined}
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`px-4 py-2 rounded-lg border ${
                            page === currentPage
                                ? 'bg-gradient-to-r from-[#61257B] to-[#C1348B] text-white border-transparent shadow-md shadow-purple-900/30'
                                : 'text-gray-700 border-gray-200 hover:bg-purple-50 hover:text-[#61257B]'
                        }`}
                    >
                        {page}
                    </button>
                ))}
                
                <button 
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={disabled || currentPage === totalPages}
                    className="px-4 py-2 text-gray-700 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Siguiente
                </button>
            </div>
        </nav>
    );
};
